const { urlapi } = require("../../lib/backend/data")

const refrescarListasPrecio = objeto => {
    return {
        type: 'refrescarListasPrecio',
        payload: objeto
    }
}

const actualizarListasPrecio = (token) => {
    return async dispatch => {
        console.log("token", token )
        return fetch(`${urlapi}/listaprecios/list/select`,{
            method:'GET',
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${token}`
            }
        })
        .then(res => res.json())
        .then(res => {
            if(Array.isArray(res) !== false){
                dispatch(refrescarListasPrecio(res))
            }
            return false
        })
        .catch(error => {
            console.log(error.message)
            return false
        })

    }
}

module.exports = {
    refrescarListasPrecio,
    actualizarListasPrecio
}